import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useLang } from "../../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-nb-deep border-t border-cool-dark relative z-10">
      <div className="max-w-[1240px] mx-auto px-5 lg:px-8 py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Logo variant="full" />
            <p className="mt-4 text-sm text-cool-light max-w-xs">{t.footer.tagline}</p>
            <p className="mt-4 text-xs text-cool-mid max-w-xs">{t.footer.status}</p>
          </div>

          <div>
            <h4 className="text-xs font-mono uppercase tracking-widest text-cyan mb-4">{t.footer.product}</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link className="text-cool-light hover:text-white transition-colors" to="/platform">{t.nav.platform}</Link></li>
              <li><Link className="text-cool-light hover:text-white transition-colors" to="/use-cases">{t.nav.useCases}</Link></li>
              <li><Link className="text-cool-light hover:text-white transition-colors" to="/industries">{t.nav.industries}</Link></li>
              <li><Link className="text-cool-light hover:text-white transition-colors" to="/pilot-program">{t.nav.pilot}</Link></li>
              <li><a className="text-cool-light hover:text-white transition-colors" href="https://investor.dynamisdecisionintelligence.com" target="_blank" rel="noopener noreferrer">{t.nav.investors}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-mono uppercase tracking-widest text-cyan mb-4">{t.footer.company}</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link className="text-cool-light hover:text-white transition-colors" to="/company">{t.nav.company}</Link></li>
              <li><Link className="text-cool-light hover:text-white transition-colors" to="/contact">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-mono uppercase tracking-widest text-cyan mb-4">{t.footer.legal}</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link className="text-cool-light hover:text-white transition-colors" to="/privacy-policy" data-testid="footer-privacy">{t.footer.privacy}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-cool-dark flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-cool-mid">© {year} Dynamis Decision Intelligence S.r.l. — {t.footer.rights}</p>
          <p className="text-xs text-cool-mid font-mono">Sense → Simulate → Solve → Execute</p>
        </div>
      </div>
    </footer>
  );
};
